import Constants from '../utils/consts';
import Cookies from 'universal-cookie';

var db = new Cookies().get('db', {path: '/' });
var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');


export default async function addLezione(uname, token, date, hour, minutes, durata, id_insegnante, altri_insegnanti, id_corso, altri_corsi, id_materia, id_aula, isOnline, join_link, host_link, join_pwd) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'addLezioneNew.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            const resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'date': date,
        'hour': hour,
        'minutes': minutes,
        'durata': durata,
        'id_insegnante': id_insegnante,
        'altri_insegnanti': altri_insegnanti,
        'id_corso': id_corso,
        'altri_corsi': altri_corsi,
        'id_materia': id_materia,
        'id_aula': id_aula,
        'is_online': isOnline,
        'join_link': join_link,
        'host_link': host_link, 
        'join_pwd': join_pwd,
        'db_name': db
        });

        req.write(postData);

        req.end();

        
    });
}
